"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseTable = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseTable = _styledComponents.default.table.withConfig({
  displayName: "Table__BaseTable",
  componentId: "sc-7fgtt2-0"
})(["border-collapse:collapse;border-spacing:0;td,th{padding:0.5em 10px 0.5em 0;text-align:left;}thead{td,th{border-bottom:1px solid #000;background-position:center right;background-repeat:no-repeat;&[aria-sort='ascending']{background-image:url('data:image/gif;base64,R0lGODlhFQAEAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAQAAAINjI8Bya2wnINUMopZAQA7');}&[aria-sort='descending']{background-image:url('data:image/gif;base64,R0lGODlhFQAEAIAAACMtMP///yH5BAEAAAEALAAAAAAVAAQAAAINjB+gC+jP2ptn0WskLQA7');}button{padding:0;border:none;background:none;color:inherit;cursor:pointer;font:inherit;outline:none;user-select:none;}}}tbody{td,th{border-bottom:1px solid #ccc;font-weight:normal;}}tfoot{td,th{border-top:1px solid #ccc;font-weight:bold;}}"]);

exports.BaseTable = BaseTable;